import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import NumberFormat from 'react-number-format';

import InputField from 'components/Form/Input';

const EditPhoneMobile = (props) => {
  const [disabled, setDisabled] = useState(true);

  const handleValueChange = () => {
    setDisabled(false);
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.toggle} size="md">
      <ModalHeader toggle={props.toggle}>
        Edit Mobile Number
        <button type="button" className="close" onClick={props.toggle} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <InputField
          label="Mobile Number"
          type="tel"
          name="mobile-number"
          id="mobileNumber"
          tag={NumberFormat}
          format="(###) ###-####"
          defaultValue="5551234567"
          onChange={handleValueChange}
        />

        <FormGroup check className="mb-3">
          <Input
            type="checkbox"
            id="Check"
            name="check"
            defaultChecked
            onChange={handleValueChange}
          />
          <Label for="Check" check>
            Set as primary number
          </Label>
        </FormGroup>

        <h5>How can we contact you?</h5>

        <FormGroup tag="fieldset" className="mb-4">
          <FormGroup check>
            <Input
              type="radio"
              id="contactPreference1"
              name="contactRadio"
              defaultChecked
              onChange={handleValueChange}
            />
            <Label for="contactPreference1" check>
              Call me or text me through automated means
            </Label>
          </FormGroup>

          <FormGroup check>
            <Input
              type="radio"
              id="contactPreference2"
              name="contactRadio"
              onChange={handleValueChange}
            />
            <Label for="contactPreference2" check>
              Only contact me through non-automated means
            </Label>
          </FormGroup>
        </FormGroup>

        <Button color="primary" className="w-100" disabled={disabled}>
          Save
        </Button>
      </ModalBody>
    </Modal>
  );
};

EditPhoneMobile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default EditPhoneMobile;
